import { useCallback, useEffect, useRef } from 'react';

import type { DialPadValue } from 'features/dial-pad/interfaces';
import { DtmfSound } from 'features/dial-pad/services';

export const useDtmfSound = () => {
  const dtmfSoundRef = useRef<DtmfSound | null>(null);

  // Initialize sound service
  useEffect(() => {
    dtmfSoundRef.current = new DtmfSound();

    return () => {
      dtmfSoundRef.current?.destroy();
      dtmfSoundRef.current = null;
    };
  }, []);

  const addSoundToQueue = useCallback((value: DialPadValue) => {
    dtmfSoundRef.current?.addToQueue(value);
  }, []);

  return {
    addSoundToQueue,
  };
};
